import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import type { JSX, SyntheticEvent } from 'react';

export interface MenuButtonItemProps {
  disabled: boolean;
  danger?: boolean;
  'data-test': string;
  isAllowedMessage: string;
  topDivider?: boolean;
  label: string;
  onClick: (e: SyntheticEvent) => void;
}

export function MenuButtonItem(props: MenuButtonItemProps): JSX.Element {
  const { disabled, danger, topDivider, onClick, label, isAllowedMessage } = props;

  return (
    <Tooltip title={isAllowedMessage}>
      <div>
        {topDivider && <Divider />}
        <MenuItem
          onClick={e => onClick(e)}
          disabled={disabled}
          data-test={props['data-test'] || 'actions-item'}
          sx={{ minWidth: 150, ...(danger && { color: 'error.main' }) }}
        >
          {label}
        </MenuItem>
      </div>
    </Tooltip>
  );
}
